import SearchIcon from "@mui/icons-material/Search";
import axios from "axios";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

export const Search = (props) => {
  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [toggleMenu, setToggleMenu] = useState(false);

  useEffect(() => {
    const getProducts = async () => {
      try {
        // eslint-disable-next-line no-unused-vars
        const result = await axios
          .get(process.env.REACT_APP_API_URL + "/product")
          .then((res) => {
            setProducts(res.data);
          });
      } catch (error) {
        console.log(error);
      }
    };
    getProducts();
  }, []);

  const handleSearch = (e) => {
    const value = e.target.value;
    const filter = products?.filter((product) =>
      product.title.toLowerCase().includes(value.toLowerCase())
    );
    if (filter.length >= 1) {
      if (props.categoriesSearch) {
        props.categoriesSearch(filter);
        setToggleMenu(false);
      } else {
        setFilteredProducts(filter);
        setToggleMenu(true);
      }
    } else {
      if (props.categoriesSearch) {
        props.categoriesSearch([]);
        setToggleMenu(false);
      } else {
        setFilteredProducts(null);
        setToggleMenu(true);
      }
    }

    if (value === "") {
      setToggleMenu(false);
      setFilteredProducts(null);
    }
  };

  return (
    <div className="relative">
      <label className="relative block">
        <span className="absolute inset-y-0 left-0 flex items-center pl-2">
          <svg className="h-5 w-5 fill-slate-300" viewBox="0 0 20 20">
            <SearchIcon htmlColor="#cbd5e1" />
          </svg>
        </span>
        <input
          className="placeholder:italic placeholder:text-slate-400 block bg-white w-full border border-slate-300 rounded-md py-2 pl-9 pr-3 shadow-sm focus:outline-none focus:border-sky-500 focus:ring-sky-500 focus:ring-1 sm:text-sm"
          placeholder="Search for product..."
          type="text"
          name="search"
          onChange={(e) => handleSearch(e)}
        />
      </label>
      {toggleMenu && (
        <div className="dropMenu absolute w-[254px] p-2 bg-white drop-shadow-lg rounded-md top-[47px] right-[calc(50%-127px)] ">
          {filteredProducts ? (
            filteredProducts.slice(0, 5).map((product) => (
              <Link key={product._id} to={`product/${product._id}`}>
                <div key={product._id} className="card flex gap-1">
                  <div className="imgBox w-12 h-12 overflow-hidden rounded flex-none mr-1">
                    <img
                      src={product.image}
                      alt={product.title}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="productInfo flex justify-between gap-2">
                    <div>
                      <h3 className="text-gray-600 text-sm font-Roboto font-medium">
                        {product.title}
                      </h3>
                      <p className="text-gray-400 text-xs font-Roboto font-medium">
                        {product.desc.slice(0, 25) + "..."}
                      </p>
                    </div>
                    <h3 className="text-gray-600 text-sm font-Roboto font-medium">
                      ${product.price}
                    </h3>
                  </div>
                </div>
              </Link>
            ))
          ) : (
            <h2 className="text-gray-500 text-sm font-Roboto font-medium text-center">
              No product found!
            </h2>
          )}
        </div>
      )}
    </div>
  );
};
